<template>
  <div class="Radar-wrap" ref="chart">
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: "Radar",
  props: [
    'info',
    'otherInfoMethod'
  ],
  components: {

  },
  data() {
    return {
      myChart: null,
      otherInfo: {
        total: 0,
        unit: ''
      },
    };
  },
  computed: {
  },
  watch: {
    info: {
      handler(val){
        this.myChart && this.myChart.dispose()
        this.$nextTick(() => {
          this.initChart()
        })
      },
      deep: true,
      immediate: true,
    }
  },
  created() {
    /* 
    
      this.info = {
        name: '示例',
        data: [ 
          // 数据配置同官方文档（https://echarts.apache.org/zh/option.html#series-radar.type）
            {
                value: [80, 30, 78, 92, 88, 65],
                name: '综合素质',
            },
        ],
        indicator: [
            {
                name: '出勤率',
                max: 100,
                min:0,
            },
            {
                name: '集体观念',
                max: 100,
                min: 0,
            },
            {
                name: '主观能动性',
                max: 100,
                min: 0,
            },]
        custom: {}, // 如果有较大的配置改动，可通过该配置（官方文档）进行覆盖
      }
    
    
    */
    
  },
  mounted() {
  },
  methods: {
    initChart(){
      let {
        data = [],
        custom = {},
        indicator = []
      } = this._.cloneDeep(this.info || {})
      let  option = {
        color: ['#59B1FF'],
        tooltip: {},
        radar: {
        axisName: {
            fontSize: 12,
            color: '#999999',
        },
        axisLine: {
          show:false,
            // lineStyle: {
            //     color: '#ebeef3',
            // },
        },
        shape: this.info.shape? this.info.shape:'circle',
        center: ['50%', '50%'],
        radius: this.info.radius? this.info.radius:'70%',
        triggerEvent: false,
        indicator:indicator,
    },
    series: [
        {
            type: 'radar',
            symbolSize: 7,
            areaStyle: {
                color: {
                    type: 'radial',
                    x: 0.5,
                    y: 0.5,
                    r: 0.5,
                    colorStops: [
                        {
                            offset: 0,
                            color: 'rgba(137, 190, 252, 0.05)', // 0% 处的颜色
                        },
                        {
                            offset: 1,
                            color: 'rgba(81, 137, 248, 0.1)', // 100% 处的颜色
                        },
                    ],
                },
            },
            lineStyle: {
                width: 2
            },
            data: data,
        },
    ],
      };



      option = this._.merge(option, custom)

      if(!this.$refs.chart){return}
      this.myChart = echarts.init(this.$refs.chart)
      this.myChart.setOption(option)
    },
    
  }
};
</script>

<style scoped lang="less">
.Radar-wrap{
  width: 100%;
  height: 100%;
}
</style>